import { useFormik } from "formik";
import FormikInput from "../../components/FormikInput";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/myContext";
import { EnglishToPersian, PersianToEnglish } from "numeral-convert";
import FormFooter from "../../components/FormFooter";
import moment from "moment-jalaali";
import { useDispatch, useSelector } from "react-redux";
import {
  editRequest,
  getDriversInfo,
  selectRequestIsRejected,
} from "./requestSlice";
import { selectRegisterBtnType } from "../common-states/commonStatesSlice";

const EditRequestForm = () => {
  const { showEditForm, handleShowForm, editFormInputs } =
    useContext(MyContext);
  const [date, setDate] = useState(editFormInputs.deliverDate);
  const [statusMessage, setStatusMessage] = useState({
    content: "",
    styles: {},
  });
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const isRejected = useSelector(selectRequestIsRejected);
  const registerBtnType = useSelector(selectRegisterBtnType);
  const { bodyArray, loading } = useSelector((state) => state.driver);

  const formik = useFormik({
    initialValues: editFormInputs,
    enableReinitialize: true,
    onSubmit: (values) => {
      let deliverDate = date
        ? moment(PersianToEnglish(date.toString()), "jYYYY/jM/jD").format(
            "YYYY/MM/DD",
          )
        : "";
      if (
        registerBtnType === "ثبت اطلاعات" &&
        (values.driverId === "" || deliverDate === null)
      ) {
        setError("تاریخ تحویل آب و راننده باید مشخص شود!");
      }
      let commonData = {
        cost: values.cost,
        description: values.description ?? "",
        driver_allocated_at_user_id: Number(localStorage.getItem("userId")),
        driver_id: registerBtnType === "رد درخواست" ? null : values.driverId,
        scheduled_time: values.deliverTime ? values.deliverTime : null,
        scheduled_to_deliver_at: deliverDate ? deliverDate : null,
        tanker_request_id: values.code,
        water_volume: values.waterVolume,
      };
      commonData =
        registerBtnType === "ثبت اطلاعات" ||
        registerBtnType === "ویرایش اطلاعات"
          ? { ...commonData, is_rejected: false }
          : registerBtnType === "رد درخواست"
            ? { ...commonData, is_rejected: true, is_confirmed_by_user: false }
            : { ...commonData, is_confirmed_by_user: true };

      dispatch(
        editRequest({
          commonData,
          code: values.code,
          registerBtnType,
          dispatch,
        }),
      );
    },
  });

  const handleDateChange = (timestamp, newDate) => {
    let new_date = EnglishToPersian(newDate);
    setDate(new_date);
  };

  useEffect(() => {
    formik.resetForm();
    setError("");
    // eslint-disable-next-line
  }, [showEditForm === false]);

  useEffect(() => {
    dispatch(getDriversInfo()); //For select options
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setDate(editFormInputs.deliverDate);
    let content = editFormInputs.nomadReceiveDate
      ? "ثبت تحویل آب توسط کاربر"
      : isRejected
        ? "این درخواست رد شده است"
        : editFormInputs.driverId
          ? "اختصاص راننده انجام شده است"
          : "این درخواست بررسی نشده است";
    let styles = editFormInputs.nomadReceiveDate
      ? { backgroundColor: "mediumseagreen", color: "white" }
      : isRejected
        ? { backgroundColor: "orangered", color: "darkred" }
        : editFormInputs.driverId
          ? { backgroundColor: "DarkTurquoise", color: "teal" }
          : { backgroundColor: "red", color: "darkred" };
    setStatusMessage({ content, styles });
    // eslint-disable-next-line
  }, [editFormInputs]);

  const inputData = [
    { name: "population", placeholder: "تعداد خانوار" },
    { name: "code", placeholder: "کد پیگیری" },
    { name: "name", placeholder: "نام درخواست دهنده" },
    { name: "waterVolume", placeholder: "حجم آب اختصاصی(لیتر)" },
    { name: "insuredLiveStock", placeholder: "تعداد دام های بیمه شده" },
    { name: "deliverTime", placeholder: "ساعت تقریبی تحویل آب" },
    { name: "waterType", placeholder: "نوع آب درخواستی" },
    // { name: "allocatedAt", placeholder: "تاریخ اختصاص راننده" },
    // { name: "allocatedByUser", placeholder: "کاربر اختصاص دهنده" },
    { name: "cost", placeholder: "هزینه آبرسانی(ریال)" },
    // { name: "nomadReceiveDate", placeholder: "تاریخ دریافت متقاضی" },
  ];

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className="flex flex-wrap justify-around items-center py-3 [&>div]:form-flex-item [&>div]:flex-col-reverse [&>div]:box-border
            [&_label]:text-right [&_label]:text-[10px] sm:[&_label]:text-xs [&_label]:text-gray-600 [&_label]:mb-1 [&_input]:input-styles
            [&_span]:text-red-600 [&_input]:text-xs sm:[&_input]:text-sm [&_span]:ml-1 [&_p.error]:formik-error"
      >
        <FormikInput
          data={inputData}
          formik={formik}
          handleChange={formik.handleChange}
          formType="editReqForm"
        />
        {/*This represents 11 inputs*/}
        <div>
          <select
            dir="rtl"
            name="driverId"
            value={formik.values.driverId}
            onChange={(e) => {
              formik.handleChange(e);

              const selectedId = e.target.value;

              console.log("selectedId:", selectedId);
              console.log(bodyArray);
              const selectedDriver = bodyArray.find(
                (item) => String(item.driver_id) === selectedId,
              );

              console.log("driver:", selectedDriver);

              if (selectedDriver) {
                formik.setFieldValue(
                  "waterVolume",
                  selectedDriver.water_source_volume ?? "",
                );
              }
            }}
            className="select-styles focus:shadow-focusShadow"
            disabled={loading}
          >
            {/* 🔥 loading state */}
            {loading ? (
              <option>در حال دریافت راننده‌ها...</option>
            ) : (
              <>
                <option value="" disabled>
                  انتخاب راننده
                </option>

                {bodyArray.map((item) => (
                  <option value={item.driver_id} key={item.driver_id}>
                    {item.name} - {item.water_source_volume}
                  </option>
                ))}
              </>
            )}
          </select>

          <span className="double-select-arrow top-2/3"></span>

          <label>
            راننده<span>*</span>
          </label>
        </div>
        <div>
          <textarea
            name="description"
            rows="1"
            value={formik.values.description}
            placeholder="توضیحات"
            onChange={formik.handleChange}
            className="input-styles focus:shadow-focusShadow hover:border-green-500"
          ></textarea>
          <label>توضیحات</label>
        </div>
        <div className="[&_input]:w-full">
          <DatePicker
            cancelOnBackgroundClick
            format="jYYYY/jMM/jDD"
            placeholder="تاریخ"
            preSelected={date.toString()}
            controlValue={true}
            inputTextAlign="center"
            customClass="border border-2 border-green-600 -left-[100%]
                                sm:-left-[50%] [&_.number]:border-2 [&_.number]:border-borderColor"
            onChange={handleDateChange}
          />
          <label>
            تعیین تاریخ تحویل آب<span>*</span>
          </label>
        </div>
      </div>
      {error && (
        <p dir="rtl" className="text-xs text-red-600 mt-0 text-right">
          {error}
        </p>
      )}
      <div
        className="w-max ml-auto py-2 px-5 rounded-md text-xs sm:text-sm my-2"
        style={statusMessage.styles}
      >
        {statusMessage.content}
      </div>
      <MyContext.Provider
        value={{
          content: statusMessage.content,
          handleShowForm,
          registerBtn:
            statusMessage.content === "اختصاص راننده انجام شده است"
              ? "ویرایش اطلاعات"
              : statusMessage.content === "این درخواست بررسی نشده است"
                ? "ثبت اطلاعات"
                : "",
        }}
      >
        <FormFooter />
      </MyContext.Provider>
    </form>
  );
};

export default EditRequestForm;
